// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Red+Hat+Display:300,regular,500,600,700,800,900,300italic,italic,500italic,600italic,700italic,800italic,900italic);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins:100,100italic,200,200italic,300,300italic,regular,italic,500,500italic,600,600italic,700,700italic,800,800italic,900,900italic);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Ubuntu:300,300italic,regular,italic,500,500italic,700,700italic);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
  --bg-primary-Clr:#F25d2C;
  --bg-primary-clr:#1E4F6c;
  --text-primary-clr: #1E4F6c;
  --text-secondary-clr:#F25d2C;
  --text-black-Clr:#050505;
  --btn-primary-clr:#F25d2C;
 --primary-hover:#ff774a;
  --btn-secondary-clr:#1E4F6c;
  --btn-secondary-HOVER:#317ba5;
  --paragraph-font-size:15px;
  --heading1-size:4rem;
  --heading2-size:3rem;

}


*{
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: "Poppins", sans-serif;
}
body{
  background-color:white; 
}
h1,h2,h3,h4,h5,h6,p,a{
  color: black;
}
ul{
 list-style-type: none; 
}

.btn-primary{
  border-radius: 3px;
  padding: 10px 18px;
  font-size: 1rem;
  text-transform:capitalize;
  background-color: var(--btn-primary-clr);
  color:white;
  font-weight:400;
  cursor: pointer;
  text-decoration: none;

}

.btn-secondary{
  border-radius: 3px;
  padding: 8px 18px;
  font-size: 1rem;
  text-transform: uppercase;
  background-color:var(--btn-secondary-clr);
  color:white;
  font-weight:400;
  cursor: pointer;
  text-decoration: none;
}

.btn-primary:hover{
background-color:var(--primary-hover);
}


.btn-secondary:hover{
  background-color: var(--btn-secondary-HOVER);
}



`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAGA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;EACxB,yBAAyB;CAC1B,uBAAuB;EACtB,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,oBAAoB;EACpB,oBAAoB;;AAEtB;;;AAGA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,kCAAkC;AACpC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;AACA;CACC,qBAAqB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,wCAAwC;EACxC,WAAW;EACX,eAAe;EACf,eAAe;EACf,qBAAqB;;AAEvB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;EACzC,WAAW;EACX,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;AACA,qCAAqC;AACrC;;;AAGA;EACE,4CAA4C;AAC9C","sourcesContent":["@import url(https://fonts.googleapis.com/css?family=Red+Hat+Display:300,regular,500,600,700,800,900,300italic,italic,500italic,600italic,700italic,800italic,900italic);\n@import url(https://fonts.googleapis.com/css?family=Poppins:100,100italic,200,200italic,300,300italic,regular,italic,500,500italic,600,600italic,700,700italic,800,800italic,900,900italic);\n@import url(https://fonts.googleapis.com/css?family=Ubuntu:300,300italic,regular,italic,500,500italic,700,700italic);\n:root{\n  --bg-primary-Clr:#F25d2C;\n  --bg-primary-clr:#1E4F6c;\n  --text-primary-clr: #1E4F6c;\n  --text-secondary-clr:#F25d2C;\n  --text-black-Clr:#050505;\n  --btn-primary-clr:#F25d2C;\n --primary-hover:#ff774a;\n  --btn-secondary-clr:#1E4F6c;\n  --btn-secondary-HOVER:#317ba5;\n  --paragraph-font-size:15px;\n  --heading1-size:4rem;\n  --heading2-size:3rem;\n\n}\n\n\n*{\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  font-family: \"Poppins\", sans-serif;\n}\nbody{\n  background-color:white; \n}\nh1,h2,h3,h4,h5,h6,p,a{\n  color: black;\n}\nul{\n list-style-type: none; \n}\n\n.btn-primary{\n  border-radius: 3px;\n  padding: 10px 18px;\n  font-size: 1rem;\n  text-transform:capitalize;\n  background-color: var(--btn-primary-clr);\n  color:white;\n  font-weight:400;\n  cursor: pointer;\n  text-decoration: none;\n\n}\n\n.btn-secondary{\n  border-radius: 3px;\n  padding: 8px 18px;\n  font-size: 1rem;\n  text-transform: uppercase;\n  background-color:var(--btn-secondary-clr);\n  color:white;\n  font-weight:400;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.btn-primary:hover{\nbackground-color:var(--primary-hover);\n}\n\n\n.btn-secondary:hover{\n  background-color: var(--btn-secondary-HOVER);\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
